import { useContext } from "react";
import { VehicleDashboardContext } from "./VehicleDashboard.context";


export function useVehicleDashboardContext(){
    const content = useContext(VehicleDashboardContext)

    if(!content){
        throw new Error("useVehicleDashboardContext deve ser utilizado apenas dentro de VehicleDashboardProvider")
    }
    return content
}